import { TFunction } from 'i18next';
import { UseFormGetValues, ValidationRule } from 'react-hook-form';

class ValidationUtils {
  public emailValidation(t: TFunction): ValidationRule<RegExp> {
    return {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: t('auth.invalidEmail'),
    };
  }

  public usernameValidation(t: TFunction): ValidationRule<any> {
    return {
      value: /^[a-zA-Z0-9.\-_$@*!]{3,30}$/,
      message: t('auth.invalidUsername'),
    };
  }

  public validatePassword(t: TFunction): ValidationRule<any> {
    return {
      validate: (password: string) => {
        const test =
          /[a-z]/g.test(password) &&
          /[A-Z]/g.test(password) &&
          /\d/g.test(password) &&
          password?.length > 7;
        if (/\s/g.test(password)) {
          return t('auth.whiteSpace');
        }

        return (
          (/[a-z]/g.test(password) &&
            /[A-Z]/g.test(password) &&
            /\d/g.test(password) &&
            password?.length > 7) ||
          t('auth.invalidPassword')
        );
      },
    };
  }

  public validatePasswordMatch(
    getValues: UseFormGetValues<any>,
    t: TFunction,
  ): ValidationRule<any> {
    return {
      validate: () => {
        const values = getValues();
        return (
          values.Password === values.ConfirmPassword ||
          t('auth.passwordMismatch')
        );
      },
    };
  }
}

const validationUtils = new ValidationUtils();

export default validationUtils;
